export const MAP_OUTER_ELEMENT_ID = (mapDomId: string) =>
  `${mapDomId}__container`;
export const MAP_ELEMENT_ID = (mapDomId: string) => `${mapDomId}__map`;
export const MAP_ACCORDION_CONTENT_ID = (mapDomId: string) =>
  `${mapDomId}__accordion_content`;
export const ELEMENT_CLASS_NAME = 'vwp-odmap-outer';
